// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"aa9e6d19","404":"d85f568b","498":"a58db1a1"}[chunkId] + ".chunk.js";
};